import type { NavigationMenuItem } from '../config/navigationMenu';

export function filterMenuByPermissions(
  items: NavigationMenuItem[],
  canPage: (path: string) => boolean,
): NavigationMenuItem[] {
  return items
    .map((item) => {
      if (item.subItems?.length) {
        const subItems = filterMenuByPermissions(item.subItems, canPage);
        if (subItems.length === 0) return null;
        return { ...item, subItems };
      }
      return canPage(item.path) ? item : null;
    })
    .filter((item): item is NavigationMenuItem => item != null);
}
